<template>
  <div class="loading" v-if="loading">
    <v-icon>mdi-circle</v-icon>
    <v-icon>mdi-circle</v-icon>
    <v-icon>mdi-circle</v-icon>
  </div>
  <div class="table" v-else="!loading">
  <div class="left-col">
    <div class="readonly-note">
      Страница только для просмотра. Стопы настраиваются в админке «Вилки-Палки» и приезжают сюда автоматически.
      <br>
      <span v-if="lastSync">Последнее обновление данных: {{ lastSync }}</span>
    </div>
    <div class="box">
      <div class="row open-category">
        <span v-if="!categoryOpen" @click="categoryOpen = !categoryOpen">показать категории</span>
        <span v-if="categoryOpen" @click="categoryOpen = !categoryOpen">скрыть категории</span>
      </div>
      <div class="row"  v-if="categoryOpen">
        <div class="header col-lg-4 col-6 diff bg-transparent"><div>Категории</div> <div class="header-check">стопы<v-checkbox type="checkbox" v-model="offCat"></v-checkbox></div></div>
      </div>
      <div class="row" v-if="categoryOpen">
        <div class="col-lg-4 col-6 diff">
          <strong>Название блюда</strong>
          <strong>На стопе в филиалах</strong>
        </div>
          <div class="col-lg-4 col-6 diff">
            <strong>Название блюда</strong>
            <strong>На стопе в филиалах </strong>
          </div>
        <div class="col-lg-4 col-6 diff">
            <strong>Название категории</strong>
            <strong>На стопе в филиалах</strong>
        </div>
        <div class="col-lg-4 col-6 diff" v-for="category in categories.filter(item => !offCat || getCatIsOnStop(item.id))">
          <div :class="'label' + (getCatIsOnStop(category.id) ? ' label-stop' : '')">{{category.name}}</div>
          <div class="selectable">
<!--            <v-autocomplete-->
<!--                v-model="valuesCat[category.id]"-->
<!--                :items="branches"-->
<!--                hide-no-data-->
<!--                multiple-->
<!--                item-text="name"-->
<!--                item-value="id"-->
<!--                return-object-->
<!--                @change="update()"-->
<!--            ></v-autocomplete>-->

            <div class="select-list">
              <div :class="isSelected(category.id, branch, true) ? 'select selected' : 'select'" v-for="branch of branches">{{branch.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="row">
        <div class=" col-lg-4 col-6">
          <div class="header diff bg-transparent">
            <div>Блюда</div>
            <div class="header-check">стопы<v-checkbox type="checkbox" v-model="offProd"></v-checkbox></div>
          </div>

          <div class="diff bg-transparent">
            <div>поиск по категориям:</div>
            <v-autocomplete
                class="category-search"
                v-model="categoriesFilter"
                :items="categories"
                hide-no-data
                multiple
                item-text="name"
                item-value="id"
                return-object
            ></v-autocomplete>
          </div>

          <div class="diff bg-transparent">
            <div>поиск по филиалу (блок):</div>
            <v-autocomplete
                class="category-search"
                v-model="branchesStopFilter"
                :items="branches"
                hide-no-data
                multiple
                item-text="name"
                item-value="id"
                return-object
            ></v-autocomplete>
          </div>



        </div>
        <div class="col-lg-8 col-6 diff bg-transparent">
          <v-text-field
              v-model="filter"
              append-icon="mdi-magnify"
          ></v-text-field>
        </div>
      </div>
        <div class="row">
          <div class="col-lg-4 col-6 diff">
            <strong>Название блюда</strong>
            <strong>На стопе в филиалах</strong>
          </div>
          <div class="col-lg-4 col-6 diff">
            <strong>Название блюда</strong>
            <strong>На стопе в филиалах</strong>
          </div>
          <div class="col-lg-4 col-6 diff">
            <strong>Название блюда</strong>
            <strong>На стопе в филиалах</strong>
          </div>
          <div class="col-lg-4 col-6 diff" v-for="product in products.filter(filteredProduct)">
            <div :class="'label' + (getIsOnStop(product)? ' label-stop' : '')">{{product.name}}</div>
            <div class="selectable">
              <div class="selectable-column">
<!--              <v-autocomplete-->
<!--                  v-model="valuesProd[product.id]"-->
<!--                  :items="branches"-->
<!--                  hide-no-data-->
<!--                  multiple-->
<!--                  item-text="name"-->
<!--                  item-value="id"-->
<!--                  return-object-->
<!--                  @change="update()"-->
<!--              ></v-autocomplete>-->
                <div class="select-list">
                  <div :class="isSelected(product.id, branch) ? 'select selected' : 'select'" v-for="branch of branches">{{branch.name}}</div>
                </div>
                <div class="hint" v-if="getFromCategory(product)">
                  категория "{{getCategoryName(product)}}" на стопе в : {{getFromCategory(product)}}
                </div>
              </div>
            </div>
          </div>
          <div v-if="!products.filter(filteredProduct).length" class="nothing col-12">Нет таких товаров</div>
        </div>

    </div>
  </div>
    <div class="right-col">

    </div>
  </div>
</template>

<script>

// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
// import 'vue-multiselect/dist/vue-multiselect.min.css'
import Vue from "vue";

export default {
  name: 'Stops',
  props: {},
  components: {},
  filters: {},
  data: () => ({
    loading: 0,
    categories: [],
    categoriesFilter: [],
    branches: [],
    branchesStopFilter: [],
    products: [],
    valuesCat: {},
    valuesProd: {},
    filter: '',
    lastSync: '',
    offCat: false,
    offProd: true,
    categoryOpen: false,
  }),
  mounted() {
    this.loading = 3;

    //branches
    Vue.axios.get('/branches').then((resB) => {
      this.branches = resB.data
          .map(({id, name}) => ({id, name}));

      this.lastSync = new Date().toLocaleString('ru-RU');

      for (const branch of resB.data) {
        const disabledItems = this.parseJson(branch.disabled_items_esho);

        const {products = [], categories = []} = disabledItems || {};

        for (const catId of categories) {
          if (!this.valuesCat[catId]) this.valuesCat[catId] = [];

          this.valuesCat[catId].push({id: branch.id, name: branch.name});
        }

        for (const productId of products) {
          if (!this.valuesProd[productId]) this.valuesProd[productId] = [];

          this.valuesProd[productId].push({id: branch.id, name: branch.name});
        }
      }


      //categories
      Vue.axios.get('/categories').then((res) => {
        this.categories = res.data
            .map(({id, name}) => ({id, name}))
            .sort((item1, item2) => item1.name.localeCompare(item2.name));

        this.loading--;
      }).catch((err) => {
        console.error(err);
        this.loading--;
      });

      //products
      Vue.axios.get('/products').then((res) => {
        this.products = res.data
            .map(({id, name, parent_group = 0}) => ({id, name, cid: parent_group}))
            .sort((item1, item2) => item1.name.localeCompare(item2.name));

        this.loading--;
      }).catch((err) => {
        console.error(err);
        this.loading--;
      });

      this.loading--;
    }).catch((err) => {
      console.error(err);
      this.loading--;
    });

  },
  watch: {},
  methods: {
    parseJson(value) {
      if (!value) return null;
      if (typeof value === 'object') return value;

      try {
        return JSON.parse(value);
      } catch (err) {
        console.error('Не удалось разобрать disabled_items_esho', err);
        return null;
      }
    },
    filteredProduct(product) {
      if (this.filter.length) {
        return product.name.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0;
      }


      if (!this.offProd || this.getIsOnStop(product)) {
        if (this.categoriesFilter.length && !this.categoriesFilter.find(category => category.id === product.cid)) {
          return false;
        }

        if (this.branchesStopFilter.length) {

          const cat = this.valuesCat[product.cid];
          const prod = this.valuesProd[product.id];

          for (const branch of this.branchesStopFilter) {
            if (cat && cat.length && cat.find(category => category.id === branch.id)) {
              return true;
            }
            if (prod && prod.length && prod.find(category => category.id === branch.id)) {
              return true;
            }
          }


          return false;
        }

        return true;
      }


      return false;
    },
    isSelected(cntId, branch, isCategory = false) {
      const where = isCategory ? this.valuesCat : this.valuesProd;

      if (!where[cntId]) {
        where[cntId] = [];
      }

      return !!where[cntId].find(item => item.id === branch.id);
    },
    getCatIsOnStop(categoryId) {
      return this.valuesCat[categoryId] && this.valuesCat[categoryId].length;
    },
    getIsOnStop(product) {
      return this.valuesProd[product.id] && this.valuesProd[product.id].length || this.getCatIsOnStop(product.cid);
    },
    getFromCategory(product) {
      const cat = this.valuesCat[product.cid];

      if (cat && cat.length) {
        return this.branches.filter(branch => cat.find(category => category.id === branch.id))
            .map(branch => branch.name)
            .join(', ');
      }

      return '';
    },
    getCategoryName(product) {
      const cat = this.categories.find(item => item.id === product.cid);

      if (cat) {
        return cat.name;
      }

      return 'Неизвестная Категория';
    },
  },
}
</script>


<style scoped lang="scss">
.loading {
  display: flex;
  min-height: 100dvh;
  justify-content: center;
  align-items: center;
}

.table {
  width: 100%;
  .left-col {

    .header-check {
      font-size: 16px;
      font-weight: 300;
      display: flex;
    }

    .header {
      font-size: 24px;
      color: #333;

      font-family: monospace, sans-serif;
      display: flex;
      align-items: center;
      .add {
        margin-left: auto;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
      }
    }

    .box {
    }

    .box + .box {
      margin-top: 30px;
    }
  }
}

.diff {
  display: flex;
  border-bottom: 2px solid silver;

  &:nth-child(3n + 1), &:nth-child(3n + 2) {
    border-right: 1px solid silver;
  }

  &:nth-child(6n + 1), &:nth-child(6n + 2), &:nth-child(6n + 3) {
    background-color: #eee;
  }

  > :nth-child(1) {
    flex-grow: 1;
    padding-right: 20px;
  }

  > :nth-child(2) {
    flex-grow: 0;
    margin-left: auto;
  }
}

.selectable {
  width: 250px;

  .v-select {
    padding-top: 0;
    margin-top: 0;
  }

  .selectable-column {
    display: flex;
    flex-direction: column;
  }

  .hint {
    margin-top: 10px;
    color: #333;
    font-size: 12px;
    text-align: right;
  }
}

.bg-transparent {
  background-color: transparent !important;
  border-right: 0 !important;
  border-bottom: 0 !important;

  .v-input {
    padding: 0;
    margin-top: 0;
  }

  .v-input__append-inner {
    margin-top: 12px;
  }
}

.label-stop {
  color: darkred;
}

.open-category {
  display: block;
  text-align: right;

  span {
    color: #777;
    text-decoration: underline;
    cursor: pointer;
    user-select: none;
  }
}

.readonly-note {
  margin-bottom: 20px;
  padding: 12px 16px;
  border: 1px solid #c8c8c8;
  border-left: 4px solid #1976d2;
  background-color: #f5f7fa;
  color: #333;
  font-size: 14px;
  line-height: 1.5;

  span {
    color: #666;
    font-size: 13px;
  }
}

.select-list {
  width: 250px;
  display: flex;
  flex-wrap: wrap;

  .select {
    border: 1px solid #333;
    background-color: #eee;
    text-align: center;
    box-shadow: 1px 1px 10px grey;
    color: #333;
    cursor: default;
    user-select: none;
    width: 45%;
    margin-bottom: 10px;
    border-radius: 5px;

    &:nth-child(2n) {
      margin-left: auto;
    }

    &.selected {
      color: darkred;
      border: 1px solid darkred;
    }
  }

}


.category-search {
  flex-grow: 1 !important;
  margin-left: 10px;
}

.nothing {
  text-align: center;
  color: #333;
  padding: 5px 10px;
}
</style>
